import { useCallback, useState } from 'react'
import { AsnBlog, AsnBlogCreate } from '../../interfaces/Asn/AsnBlog'

import { apiCall, ApiConfig } from '../../config/api'

const useAsnBlogs = () => {
  const [asnBlogs, setAsnBlogs] = useState<AsnBlog[]>([])

  const [errorGetAsn, setError] = useState<string | undefined>(undefined)
  const [errorPostAsn, setErrorSend] = useState<string | undefined>(undefined)

  const [loading, setLoading] = useState<boolean>(false)

  const getAsnBlogs = useCallback(
    async (asnId: number, asnNumber: string, isSummary: boolean = false) => {
      setLoading(true)
      apiCall(
        'GET',
        ApiConfig.AsnBlogApi +
          `/GetAsnBlogEntries?asnId=${asnId}&asnNumber=${asnNumber}&IsSummary=${isSummary}`
      )
        .then((response) => {
          if (response.status !== 200) {
            throw new Error(`No fue posible obtener los registros.`)
          }
          setAsnBlogs(response.data)
          setError(undefined)
        })
        .catch(({ data: { message } }) => {
          setError(message)
        })
        .finally(() => setLoading(false))
    },
    []
  )

  const postAsnBlogs = useCallback(async (asnBlog: AsnBlogCreate) => {
    setLoading(true)
    apiCall('POST', ApiConfig.AsnBlogApi, asnBlog)
      .then((response) => {
        if (response.status !== 200) {
          throw new Error(`No fue posible obtener los registros.`)
        }

        getAsnBlogs(asnBlog.asnId, asnBlog.asnNumber!)
        return response.data
      })
      .then(() => {})
      .catch(({ data: { errors } }) => {
        setErrorSend(errors?.Comments.join(', '))
      })
      .finally(() => setLoading(false))
  }, [])

  return {
    loading,
    errorGetAsn,
    errorPostAsn,
    getAsnBlogs,
    postAsnBlogs,
    asnBlogs
  }
}

export default useAsnBlogs
